<template>
	
  <div class="home">
	 <Bar />
   <div class="home-ct">
<div class="register">
	<div class="re-tit">
		<h4>REGISTER</h4>
		
		<p>Please fill in all the mandatory fields marked with *</p>
	</div>
	
	
	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top" class="demo-ruleForm" size="mini">
		<el-row :gutter="20">
			 <el-col :span="12">
	  <el-form-item label="First name" prop="first_name">
	    <el-input v-model="ruleForm.first_name"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Last name" prop="last_name">
	    <el-input v-model="ruleForm.last_name"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Email" prop="email">
	    <el-input v-model="ruleForm.email"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Password" prop="password" >
	    <el-input  v-model="ruleForm.password" show-password></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Phone" prop="phone">
	    <el-input v-model="ruleForm.phone"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Nickname" >
	    <el-input v-model="ruleForm.nickname"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	
	 <el-row :gutter="20">
	 			 <el-col :span="12">

	   <el-form-item label="Country / Region"  prop="countory">
	      <el-select v-model="ruleForm.countory" placeholder="Please fill in Countory">
	        <el-option v-for="item in news" :label="item.NAME" :value="item.NAME"></el-option>
	  
	      </el-select>
	    </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="ID" prop="identity_id">
	    <el-input v-model="ruleForm.identity_id" placeholder="China and Taiwan must fill in the ID card number"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="Address Line 1 (Only half-width characters/numbers are valid)" prop="address_line_one">
	    <el-input v-model="ruleForm.address_line_one"></el-input>
	  </el-form-item>
	  </el-col>

	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="Address Line 2 (Only half-width characters/numbers are valid)" prop="address_line_two">
	    <el-input v-model="ruleForm.address_line_two"></el-input>
	  </el-form-item>
	  </el-col>
	 
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="Line account" prop="line_account">
	    <el-input v-model="ruleForm.line_account"></el-input>
	  </el-form-item>
	  </el-col>
	 
	 </el-row>
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Province" prop="province">
	    <el-input v-model="ruleForm.province"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Town / City" prop="city">
	    <el-input v-model="ruleForm.city"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Postcode / ZIP" prop="postcode">
	    <el-input v-model="ruleForm.postcode"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
		  <el-form-item  label="Date of Birth" prop="birthday">
		    <el-date-picker type="date" v-model="ruleForm.birthday" style="width: 100%;"></el-date-picker>
		  </el-form-item>
		  
	 
	  </el-col>
	 </el-row>
	 
	 <el-row :gutter="20">
	 	<el-col :span="12">
	  <el-form-item label="Instagram" prop="instagram">
	    <el-input v-model="ruleForm.instagram"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Facebook" prop="facebook_id">
	    <el-input v-model="ruleForm.facebook_id"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	
	<div class="h-button" @click="submitForm('ruleForm')">REGISTER</div>
	 
	 
	  </el-form-item>
	</el-form>
	
</div>
   </div>
   <Sim />
   <Place />
    </div>
</template>
<script>

import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'
import Sim from '@/components/sim/sim'

export default {
  components: {
  Bar,Place,Sim
  },
  data() {
    return {
            ruleForm: {
				first_name:'',
				last_name:'',
				email:'',
				password:'',
				phone:'',
				nickname:'',
				countory:'',
				identity_id:'',
				address_line_one:'',
				address_line_two:'',
				line_account:'',
				province:'',
				city:'',
				postcode:'',
				birthday:'',
				instagram:'',
				facebook_id:''
                
                  },
                  rules: {
					
					   first_name: [
					    { required: true, message: 'Please fill in First name', trigger: 'blur' },
				],last_name: [
					    { required: true, message: 'Please fill in Last name', trigger: 'blur' },
				],email: [
					    { required: true, message: 'Please fill in Email', trigger: 'blur' },
				],password: [
					    { required: true, message: 'Please fill in Password', trigger: 'blur' },
				],phone: [
					    { required: true, message: 'Please fill in Phone', trigger: 'blur' },
				],countory: [
					    { required: true, message: 'Please fill in Countory', trigger: 'change' },
				],address_line_one: [
					    { required: true, message: 'Please fill in Address Line 1', trigger: 'blur' },
				],province: [
					    { required: true, message: 'Please fill in Province', trigger: 'blur' },
				],city: [
					    { required: true, message: 'Please fill in City', trigger: 'blur' },
				],postcode: [
					    { required: true, message: 'Please fill in Postcode', trigger: 'blur' },
				]
                 
                  },news:''
          };
  },  mounted() {
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
				
				localStorage.clear()
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_emailRegister",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
			
		     this.$alert(data.message, '提示', {
		              confirmButtonText: '确定',
		              callback: action => {
		              this.$router.push({ path: "/login" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      },sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=userAddress_country",
				  data: {},  
				}).then((res) => {
					let data=res.data;
				
					if(data.code==1){
						this.news=data.data;
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss" scoped>
	.h-button{
		text-align: center;
		cursor: pointer;
		width: 185px;
		padding: 0 50px;
		height: 50px;
		line-height: 50px;
		background: #000;
		color: #FFFFFF;
		margin:20px auto;
	}
	.h-button:hover{
		background-color: #333333;
	}
.register{
	padding: 20px 0;
	.re-tit{
		line-height: 50px;
		h4{
			font-size: 26px;
		}
		margin-bottom: 20px;
	}
}	
	

</style>